<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar :placeholder="true" :fixed="true" title="旁站列表" left-text="返回" left-arrow @click-left="goBack">
				<template #right>
					<van-icon v-if="showAdd" size="26" name="add-o" @click="toAdd"/>
				</template>
			</van-nav-bar>
		</div>
		<!-- 下拉刷洗 -->
		<van-pull-refresh v-model="isRefreshLoading" success-text="刷新成功" @refresh="onRefresh">
			<van-list
				v-model="loading"
				:finished="finished"
				finished-text="没有更多了"
				:error.sync="error"
				error-text="请求失败，点击重新加载"
				@load="loadMore"
			>
				<div class="patrolList" v-for="item in dataList" :key="item.recId" @click="goDetail(item.recId)">
					<div class="notesTop">
						<div class="patrolTitle">{{item.subjectName}}</div>
					</div>
					<div class="patrolDesc">部位：{{item.onsitePosition}}</div>
					<div class="patrolDesc">项目：{{item.onsiteItem}}</div>
					<div class="patrolDesc">{{item.onsiteContent}}</div>
					<div class="patrolTime">
						{{item.beginTime}} {{item.bystander}}
						<van-button v-if="showEdit" type="info" class="darkEqWidthBtn" size="small" @click.stop="goEdit(item.recId)">修改</van-button>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
	import { list } from '../../api/qualityStation'
	import common from '../../utils/common';

	export default {
		name: 'qualitySideStationList',
		data() {
			return {
				isRefreshLoading: false,
				error: false,
				loading: false,
				finished: false,
				dataList: [],
				// 项目名称
				projectName: '',
				// 查询传递对象
				queryParam: {
					page: 0,
					limit: 10,
					workNo: null,
					// PC端传值category=1，范畴：质量=1；安全=2；进度=3
					category: 1,
				},
				showAdd: false,
				showEdit: false,
			}
		},
		mounted() {
			this.project = common.getProject();
			if(this.project == null || this.project == undefined){
				Notify({ type: 'danger', message: '获取项目信息失败' });
			}
			this.queryParam.workNo = this.project.workNo;
			this.projectName = this.project.projectName;
			if (common.hasPermision("station:add:1")) {
				this.showAdd = true;
			}
			if (common.hasPermision("station:edit:1")) {
				this.showEdit = true;
			}
		},
		methods: {
			goBack() {
				this.$router.push({
					name: 'workbench'
				});
			},
			toAdd(){
				this.$router.push({
					name: 'qualitySideStationAdd',
				});
			},
			goEdit(id){
				this.$router.push({
					name: 'qualitySideStationEdit',
					query: {"id": id}
				});
			},
			goDetail(id){
				if (!common.hasPermision("station:search:1")) {
					return;
				}
				this.$router.push({
					name: 'qualitySideStationDetail',
					query: {"id": id}
				});
			},
			onRefresh(){
				this.finished = false;
				this.loading = true;
				this.queryParam.page = 1;
				this.dataList = [];
				this.onLoad();
			},
			loadMore(){
				this.queryParam.page += 1;//页数+1
      			this.onLoad();
			},
			onLoad(){
				if (this.isRefreshLoading){
					this.queryParam.page = 1;
					this.dataList = [];
					this.isRefreshLoading = false;
				}
				this.queryParam.t = new Date().getTime()
				list(this.queryParam).then(response => {
					this.loading = false
					if (response.data.resultCode === 200){
						// 检索结果明细
						this.dataList = this.dataList.concat(response.data.body.records);
						if (response.data.body.records.length === 0) {
							this.finished = true;
						}
					}else{
						this.finished = true;
					}
				})
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>